// axios
import axios from "axios";
// import Vue from "vue";
//import store from "@/store";
// import router from "@/router";

/**
 * 建立請求器
 * @type {axios.AxiosInstance}
 */
const axiosIns = axios.create({
  //範例
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
  timeout: 15000, //等待回應豪秒數
  //withCredentials:true,
  baseURL: ``,
  headers: {},
});
/**
 * 請求前的判斷處理
 */
axiosIns.interceptors.request.use(
  (config) => {
    // 取得目前的TOKEN並驗証
    //const accessToken = localStorage.getItem('accessToken')
    const accessToken = window.$cookies.get("accessToken");

    // 加入驗証的標頭值
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * 請求後處理
 */
axiosIns.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("axios", error);
    const { status } = error.response;
    //判斷 401 代表驗証錯誤，清掉所有的記錄
    if (status == 401) {
      //Message.closeAll();
      //Message.error("您已被系統登出，請重新登入");
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("tokenTime");
      sessionStorage.removeItem("refreshTime");
      sessionStorage.removeItem("lang");

      //路由轉向到登入
      // router.push({ name: "login" });
    }
    return Promise.reject(error);
  }
);

//Vue.prototype.$http = axiosIns

export default axiosIns;
